import React__default from 'react';
import { AddressSearchForm } from '@grandvisionhq/locations';

const AddressLookup = ({ displayError , displayIsValid , errorMessage , inputFieldName , label , onResult , required =true , setIsTouched , streetName , updateForm  })=>/*#__PURE__*/ React__default.createElement("label", {
        className: "address-lookup form-control"
    }, /*#__PURE__*/ React__default.createElement("span", {
        className: "form-control__label"
    }, label, required && /*#__PURE__*/ React__default.createElement("span", {
        className: "form-control__asterisk"
    }, "*")), /*#__PURE__*/ React__default.createElement(AddressSearchForm, {
        inputFieldName: inputFieldName,
        isInvalid: displayError,
        isValid: displayIsValid,
        onResult: onResult,
        setIsTouched: setIsTouched,
        streetName: streetName,
        updateForm: updateForm
    }), displayError && /*#__PURE__*/ React__default.createElement("span", {
        id: "address-lookup",
        className: "form-control__error"
    }, errorMessage))
;

export { AddressLookup };
//# sourceMappingURL=AddressLookup.js.map
